import {MenuItemType} from '@models/sidebar/menu-item-type';
import {MenuItemIcon} from '@models/sidebar/menu-item-icon';

export class PageTypeOption {
  icon: MenuItemIcon = MenuItemIcon.NONE;
  value: MenuItemType = MenuItemType.NONE;
  label: string = '';

  constructor(value: MenuItemType, label: string, icon: MenuItemIcon) {
    this.value = value;
    this.label = label;
    this.icon = icon;
  }
}
